module.exports = __webpack_public_path__ + "static/media/CH.0089f071.png";